import React, { useState, useEffect, useRef } from "react";
import httpClient from "../../lib/HttpClient";
import axiosClient from "../../lib/axios-client";
import download from "downloadjs";
import security from "../../services/Security";
import axios from "../../lib/axios-client";
import { CSSTransition } from "react-transition-group";
import { Col } from "react-grid-system";
import VideoApp from "../Video/VideoApp";
import { loadDocumentUrl } from "../../lib/axios-client";

import DownloadSVG from "../../images/icons/svg/share-link-download-mobile.svg";
import mobileMenu from "../../images/icons/svg/mobile-menu-icon.svg";
import CloseSVG from "../../images/icons/svg/close-black.svg";
import OopsImage from "../../images/icons/svg/oops-image.svg";
import ApprovedImage from "../../images/icons/svg/approved-banner.svg";
import styles from "./GuestViewer.module.scss";

import ConversationsPanel from "../Documents/ConversationsPanel";
import CommentPanel from "../Documents/CommentPanel";
import SidePanelSection from "../Documents/SidePanelSection";
import ApprovalCard from "../Documents/ApprovalCard";
import ApprovalCardMobile from "../Documents/ApprovalCardMobile";
import PDFTGuestViewer from "./PDFTGuestViewer";

const GuestViewer = (props) => {
  const hashUrl = props.match.params.hash_url;

  const [video, setVideo] = useState(null);
  const [error, setError] = useState(false);
  const [duration, setDuration, durationRef] = useStateRef(0);
  const [intervalId, setIntervalId] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [showConversations, setShowConversations] = useState(false);
  const [conversationSelected, setConversationSelected] = useState(null);
  const [documentId, setDocumentId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(null);
  const [signatures, setSignatures] = useState([]);
  const [userSignatures, setUserSignatures] = useState([]);
  const [approval, setApproval] = useState({});
  const [approvalSubmitted, setApprovalSubmitted] = useState(null);
  const [session, setSession] = useState({});
  const [annotationsRetrieved, setAnnotationsRetrieved] = useState(false);
  const [showMobileSidePanel, setShowMobileSidePanel] = useState(false);
  const [documentApproved, setDocumentApproved] = useState(false);
  const [showCommentsPanel, setShowCommentsPanel] = useState(false);
  const [conversationBlockId, setConversationBlockId] = useState(null);

  const [currentXFDFHighlightString, setCurrentXFDFHighlightString] =
    useState(null);
  const [guestUserId, setGuestUserId] = useState(null);
  const [sessionId] = useState(
    [...Array(32)].map(() => Math.random().toString(36)[2]).join("")
  );
  // Ref for exposing annotation deletion from PDFTGuestViewer to this component.
  // Set by PDFTGuestViewer's handleViewerReady, used by onCloseCommentPanel.
  var deleteAnnotationRef = useRef(null);

  const toggleMobileMenu = () => {
    if (showMobileSidePanel) {
      setShowMobileSidePanel(false);
    } else {
      setShowMobileSidePanel(true);
    }
  };

  const renderApprovalSubmitted = (approval) => {
    let statusMessage;
    if (approval.status === "submit_new_version") {
      statusMessage = "New version requested";
    } else if (approval.status === "approved") {
      statusMessage = "Approved";
    } else if (approval.status === "approve_with_changes") {
      statusMessage = "Approved with changes";
    }
    setTimeout(() => setApprovalSubmitted(null), 3000);
    return <div className={styles.submissionConfirmation}>{statusMessage}</div>;
  };

  const loadConversations = () => {
    httpClient
      .get(`/documents/${documentId}/share_link/conversations/${hashUrl}.json`)
      .then((response) => {
        setConversations(response.data);
      });
  };

  const handleVisibilityChange = async () => {
    if (document.visibilityState === "hidden") {
      await httpClient.put("/share_links/session/duration", {
        hash_url: hashUrl,
        session_id: sessionId,
        duration: durationRef.current,
      });
      setDuration(0);
      clearInterval(intervalId);
    } else {
      const intervalId = setInterval(() => {
        setDuration((value) => value++);
      }, 1000);
      setIntervalId(intervalId);
    }
  };

  const beforeunload = async () => {
    httpClient.put("/share_links/session/duration", {
      hash_url: hashUrl,
      session_id: sessionId,
      duration: durationRef.current,
    });
  };

  let documentContainer = null;

  useEffect(() => {
    httpClient
      .get(`${loadDocumentUrl()}/share_links/view/${hashUrl}`)
      .then((res) => {
        setVideo(res.data.video_document);

        const retrieveAnnotations = async () => {
          const sessionResponse = await httpClient.post(
            `/share_links/session/create.json`,
            {
              hash_url: hashUrl,
              session_id: sessionId,
            }
          );

          setConversationBlockId(`${sessionResponse.data.id}-general`);

          setDocumentApproved(sessionResponse.data.is_approved);

          setSession(sessionResponse.data);

          setGuestUserId(sessionResponse.data.guest_user_id);

          setDocumentId(sessionResponse.data.id);

          const beforeunload = async () => {
            httpClient.put("/share_links/session/duration", {
              hash_url: hashUrl,
              session_id: sessionId,
              duration: durationRef.current,
            });
          };

          const counterInterval = setInterval(() => {
            setDuration((prevDuration) => prevDuration + 1);
          }, 1000);

          setIntervalId(counterInterval);

          document.addEventListener("visibilitychange", handleVisibilityChange);

          document.addEventListener("beforeunload", beforeunload);

          // Get User Signatures
          const userSignaturesResponse = await httpClient.get(
            `/guest_user_signatures/${hashUrl}.json`
          );
          setUserSignatures(userSignaturesResponse.data);

          // Get Document Signatures
          const documentSignaturesResponse = await httpClient.get(
            `/documents/${sessionResponse.data.id}/guest_signatures/${hashUrl}.json`
          );

          setSignatures(documentSignaturesResponse.data);

          // Get Approval
          const documentApprovalsResponse = await httpClient.get(
            `/documents/${sessionResponse.data.id}/guest_user_approval/${sessionResponse.data.guest_user_id}/${hashUrl}.json`
          );
          setApproval(documentApprovalsResponse.data);

          // Get Comments
          const conversationsResponse = await httpClient.get(
            `/documents/${documentApprovalsResponse.data.id}/share_link/conversations/${hashUrl}.json`
          );

          setConversations(conversationsResponse.data);

          // Check if all annotations are retrieved, once they are, set annotationsRetrieved to true so that the document can be loaded
          if (
            sessionResponse &&
            userSignaturesResponse &&
            documentSignaturesResponse &&
            documentApprovalsResponse &&
            conversationsResponse
          ) {
            setAnnotationsRetrieved(true);
          }
        };

        retrieveAnnotations();

        return () => {
          window.removeEventListener("beforeunload", beforeunload);
        };
      })
      .catch((error) => {
        setError(true);
      });
  }, []);

  const conversationsSectionClicked = () => {
    if (video) {
      setShowCommentsPanel(true);
    } else {
      setShowConversations(true);
    }
  };

  const onCloseCommentPanel = (
    closeConversationsPanel = false,
    removeHighlight
  ) => {
    if (removeHighlight) {
      if (deleteAnnotationRef.current) {
        deleteAnnotationRef.current(conversationSelected);
      }
      setConversationSelected(null);
    } else {
      if (video) {
        setShowCommentsPanel(false);
      } else {
        setConversationSelected(null);
      }
    }
  };

  const onCloseConversationPanel = () => {
    setShowConversations(false);
  };

  const onAnnotationSelect = (pageIndex, xfdfHighlightId) => {
    setConversationSelected(xfdfHighlightId);
  };

  const renderSidePanel = (document) => {
    let annotationCommentsCount = conversations.length;

    if (showMobileSidePanel) {
      return (
        <div className={styles.mobileSidePanelContainer}>
          <div className={styles.notCommentPanel}>
            {Object.keys(approval).length > 0 && renderApprovalCard()}
            {
              <SidePanelSection
                clickAction={() => conversationsSectionClicked()}
                type={"comments"}
                count={conversations.length > 0 && annotationCommentsCount}
                showMobileSidePanel={showMobileSidePanel}
              />
            }
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={
            video ? styles.videoSidePanelContainer : styles.sidePanelContainer
          }
        >
          <div className={styles.notCommentPanel}>
            {Object.keys(approval).length > 0 && renderApprovalCard()}
            {
              <div className={styles.sidePanelSectionContainer}>
                <SidePanelSection
                  clickAction={() => conversationsSectionClicked()}
                  type={"comments"}
                  count={conversations.length > 0 && annotationCommentsCount}
                />
              </div>
            }
          </div>
        </div>
      );
    }
  };

  const renderApprovalCard = () => {
    return (
      <div className={styles.approvalCardContainerSidePanel}>
        {!approval.observer && (
          <div
            className={`${styles.sidePanelOptions} ${styles.sidePanelOptionsMyApproval}`}
          >
            <ApprovalCard
              hashUrl={props.match.params.hash_url}
              approval={approval}
              inGuestViewer={true}
              updateApproval={setApproval}
            />
          </div>
        )}
        <div className={styles.divider}></div>
      </div>
    );
  };

  const renderApprovalCardMobile = () => {
    return (
      <div className={styles.approvalCardContainer}>
        {!approval.observer && (
          <div
            className={`${styles.sidePanelOptions} ${styles.sidePanelOptionsMyApproval}`}
          >
            <ApprovalCardMobile
              setApprovalSubmitted={setApprovalSubmitted}
              hashUrl={props.match.params.hash_url}
              approval={approval}
              inGuestViewer={true}
              updateApproval={setApproval}
            />
          </div>
        )}
        <div className={styles.divider}></div>
      </div>
    );
  };

  const downloadVideoFile = () => {
    const url = `/share_links/download`;
    const token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hash_url: hashUrl,
        session_id: sessionId,
        video_download: true,
      },
    });

    axios({
      method: "get",
      url: video.video_download_url,
      responseType: "arraybuffer",
    }).then(function (response) {
      download(response.data, video.video_file_name);
    });
  };

  const downloadDoc = () => {
    const url = `/share_links/download`;
    const title = `${session.title}${session.file_extension}`;
    const type = session.mime_type;
    const token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hash_url: hashUrl,
        session_id: sessionId,
      },
    }).then(function (response) {
      download(response.data, title, type);
    });
  };

  return (
    <div className={styles.reviewerScreenContainer}>
      <div id="usersScreenHeader"></div>
      <div className={styles.headerContainer}>
        {video && !documentApproved && (
          <div className={styles.header} id="document_view_header">
            {video && video.document_title}
          </div>
        )}
        {video && !documentApproved && (
          <button
            className={styles.downloadButtonDesktop}
            onClick={() => downloadVideoFile()}
          >
            Download
          </button>
        )}
        {video && !documentApproved && (
          <div
            className={styles.downloadButtonMobile}
            onClick={() => downloadVideoFile()}
          >
            <img src={DownloadSVG} />
          </div>
        )}
        {!video && !error && !documentApproved && (
          <React.Fragment>
            <div className={styles.header} id="document_view_header">
              {session.title ? `${session.title}` : ""}
            </div>
            <button
              className={styles.downloadButtonDesktop}
              onClick={() => downloadDoc()}
            >
              Download
            </button>
            <div
              className={styles.downloadButtonMobile}
              onClick={() => downloadDoc()}
            >
              <img src={DownloadSVG} />
            </div>
          </React.Fragment>
        )}
        {!error && !documentApproved && (
          <div className={styles.menuContainer}>
            {!showMobileSidePanel && (
              <img
                src={mobileMenu}
                onClick={() => {
                  toggleMobileMenu();
                }}
              />
            )}
            {showMobileSidePanel && (
              <img
                src={CloseSVG}
                onClick={() => {
                  toggleMobileMenu();
                }}
              />
            )}
          </div>
        )}
      </div>
      <div
        className={
          Object.keys(approval).length > 0 && approval.status === "pending"
            ? styles.containerApprovalsPresent
            : styles.container
        }
        id="document_container"
      >
        {!error && !documentApproved && (
          <React.Fragment>
            {video && (
              <React.Fragment>
                <Col
                  sm={9}
                  ref={(element) => {
                    documentContainer = element;
                  }}
                >
                  <VideoApp doc={video} documentContainer={documentContainer} />
                </Col>{" "}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {!video && annotationsRetrieved && !error && !documentApproved && (
          <PDFTGuestViewer
            guestUserId={guestUserId}
            documentId={documentId}
            approval={approval}
            conversations={conversations}
            hashUrl={hashUrl}
            setConversationSelected={setConversationSelected}
            setCurrentXFDFHighlightString={setCurrentXFDFHighlightString}
            setCurrentPageIndex={setCurrentPageIndex}
            setError={setError}
            reloadConversations={loadConversations}
            deleteAnnotationRef={deleteAnnotationRef}
          />
        )}
        {!error &&
          annotationsRetrieved &&
          !documentApproved &&
          renderSidePanel()}
        <CSSTransition
          in={showConversations}
          classNames="slide"
          unmountOnExit
          timeout={300}
        >
          <ConversationsPanel
            inGuestViewer={true}
            showMobileSidePanel={showMobileSidePanel}
            conversations={conversations}
            closeConversationsPanel={onCloseConversationPanel}
            showAnnotationComments={onAnnotationSelect}
            reloadConversations={loadConversations}
            hashUrl={props.match.params.hash_url}
          />
        </CSSTransition>
        <CSSTransition
          in={conversationSelected || showCommentsPanel}
          classNames="slide"
          unmountOnExit
          timeout={300}
        >
          <CommentPanel
            conversationBlockId={conversationBlockId}
            is_video={video}
            docId={documentId}
            showMobileSidePanel={showMobileSidePanel}
            inGuestViewer={true}
            currentXfdfHighlightId={conversationSelected}
            closeConversation={onCloseCommentPanel}
            deleteAnnotationById={(annotationId) => {
              if (deleteAnnotationRef.current) {
                deleteAnnotationRef.current(annotationId);
              }
            }}
            pageNumber={currentPageIndex}
            currentXfdfHighlightString={currentXFDFHighlightString}
            hashUrl={props.match.params.hash_url}
            reloadConversations={loadConversations}
            conversationSelected={conversationSelected}
            guestUserId={guestUserId}
            selectedConversationId={
              conversations.length > 0 &&
              conversations.find(
                (c) => c.xfdf_highlight_id === conversationSelected
              )
                ? conversations.find(
                    (c) => c.xfdf_highlight_id === conversationSelected
                  ).id
                : null
            }
          />
        </CSSTransition>
        {error && (
          <div className={styles.errorState}>
            <div className={styles.text}>
              <div className={styles.header}>oops!</div>
              <div className={styles.text}>
                Looks like this link no longer exists
              </div>
            </div>
            <div className={styles.image}>
              <img src={OopsImage} />
            </div>
          </div>
        )}
        {error && (
          <div className={styles.mobileErrorState}>
            <div className={styles.errorImage}>
              <img src={OopsImage} />
            </div>
            <div className={styles.mobileErrorStateText}>
              <div className={styles.mobileErrorStateHeader}>oops!</div>
              <div className={styles.Errortext}>
                Looks like this link no longer exists
              </div>
            </div>
          </div>
        )}
        {!error && documentApproved && (
          <div className={styles.errorState}>
            <div className={styles.text}>
              <div className={styles.header}>Approved!</div>
              <div className={styles.text}>
                Looks like this content is already approved
              </div>
            </div>
            <div className={styles.image}>
              <img src={ApprovedImage} />
            </div>
          </div>
        )}
        {!error && documentApproved && (
          <div className={styles.mobileErrorState}>
            <div className={styles.errorImage}>
              <img src={ApprovedImage} />
            </div>
            <div className={styles.mobileErrorStateText}>
              <div className={styles.mobileErrorStateHeader}>Approved!</div>
              <div className={styles.Errortext}>
                Looks like this content is already approved
              </div>
            </div>
          </div>
        )}
      </div>
      {Object.keys(approval).length > 0 &&
        approval.status === "pending" &&
        renderApprovalCardMobile()}
      {approvalSubmitted && renderApprovalSubmitted(approvalSubmitted)}
    </div>
  );
};

const useStateRef = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref];
};

export default GuestViewer;
